import { render, staticRenderFns } from "./PricingStep.vue?vue&type=template&id=5637a5b8&scoped=true"
import script from "./PricingStep.vue?vue&type=script&lang=js"
export * from "./PricingStep.vue?vue&type=script&lang=js"
import style0 from "./PricingStep.vue?vue&type=style&index=0&id=5637a5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637a5b8",
  null
  
)

export default component.exports